/**
 * @description Directory for ID Attributes on Reports.
 * Naming Convention: "data-test-id-[VIEW/COMPONENT]-[ELEMENT]-[NAME]".
 * Example: id = "data-test-id-mainlayout-btn-cancel".
 */
const idDirectory = {
    divGrid: `reports-div-grid`,
    divFilters: `reports-div-filters`,
    divSection: `reports-div-section`,
    divChart: `reports-div-chart`,
}

export default idDirectory
